import { meetsAxiosProtected as axios } from '../httpInstance/http'

export const getSets = () => axios.get(`/set?status=complete`)

export const startQuiz = (roomName, quizSetId) =>
    axios.post(`/${roomName}/quiz/`, { set: quizSetId })

export const getActiveQuestion = roomName => axios.get(`/${roomName}/quiz/`)
